import { createGlobalStyle } from "styled-components";

import "./theme/fonts.css";
import theme from "./theme";
import { isMobile } from "react-device-detect";

const { font } = isMobile ? theme.mobile : theme.desktop;

const GlobalStyle = createGlobalStyle`
  html {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-smooth: never;
    
    font-size: 100%;
    height: 100%;
    width: 100%;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    font-family: ${font.family};
    font-display: swap;
    margin: 0;
    min-height: 100%;
    width: 100%;
  }
`;

export default GlobalStyle;
